export default "__VITE_ASSET__DToAmCql__"